<template>
  <div>
    <v-sheet elevation="0" color="#57bc90" style="min-height: 100vh">
      <!-- //* game summary weekly... -->
      <div class="pa-2">
        <p class="text-h5 white--text font-weight-bold pt-3">Recent Game</p>
        <v-data-table
          :headers="header"
          :items="stats.data"
          class="elevation-1"
          hide-default-footer
          sort-by="Week"
          sort-desc
          mobile-breakpoint="0"
        >
          <!-- header -->
          <template
            v-for="h in header"
            v-slot:[`header.${h.value}`]="{ header }"
          >
            <v-tooltip bottom :key="h.text">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ h.text }}</span>
              </template>
              <span>{{ h.hint }}</span>
            </v-tooltip>
          </template>
          <!-- header -->

          <template v-slot:item.Day="{ item }">
            <p class="blue--text">{{ item.Day | dayFormatV2 }}</p>
          </template>

          <template v-slot:item.FantasyPointsDraftKings="{ item }">
            <p v-if="operator === 'FanDuel'" class="body-2">
              {{ item.FantasyPointsFanDuel }}
            </p>

            <p v-if="operator === 'DraftKings'" class="body-2">
              {{ item.FantasyPointsDraftKings }}
            </p>
          </template>
        </v-data-table>
      </div>

      <!-- //* season stats... -->
      <div class="mt-n3 pa-2">
        <p class="text-h5 white--text font-weight-bold mt-3">Season Logs</p>
        <v-data-table
          :headers="seasonHeader"
          :items="seasonStats.data"
          class="elevation-1"
          hide-default-footer
          sort-by="Day"
          sort-desc
          mobile-breakpoint="0"
        >
          <template
            v-for="h in seasonHeader"
            v-slot:[`header.${h.value}`]="{ seasonHeader }"
          >
            <v-tooltip bottom :key="h.text">
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ h.text }}</span>
              </template>
              <span>{{ h.hint }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.Day="{ item }">
            <p class="blue--text">{{ item.Day | dayFormatV2 }}</p>
          </template>

          <template v-slot:item.FantasyPointsDraftKings="{ item }">
            <p v-if="operator === 'FanDuel'" class="body-2">
              {{ item.FantasyPointsFanDuel }}
            </p>

            <p v-if="operator === 'DraftKings'" class="body-2">
              {{ item.FantasyPointsDraftKings }}
            </p>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "NflSummary",
  props: {
    stats: {
      type: [Array, Object],
      default: () => [],
    },
    seasonStats: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      operator: localStorage.getItem("gameOperator"),
      header: [
        { text: "Week", value: "Week", width: "auto" },
        { text: "Opponent", value: "Opponent", width: "10px" },
        { text: "FUM", value: "Fumbles", hint: "fumbles" },
        { text: "FF", value: "FumblesForced", hint: "fumbles forced" },
        { text: "LNG", value: "ReceivingLong", hint: "Receiving long" },
        { text: "TGT", value: "ReceivingTargets", hint: "Receiving target" },
        {
          text: "TD",
          value: "ReceivingTouchdowns",
          hint: "Receiving touchdowns",
        },
        { text: "YDS", value: "ReceivingYards", hint: "Receiving yards" },
        { text: "REC", value: "Receptions", hint: "Receptions" },
        { text: "ATT", value: "RushingAttempts", hint: "Rushing Attempts" },
        { text: "LNG", value: "RushingLong", hint: "Rushing long" },
        {
          text: "TD",
          value: "RushingTouchdowns",
          hint: "Rushing touchdowns",
        },
        { text: "YDS", value: "RushingYards", hint: "Rushing yards" },
        {
          text: "FP",
          value: "FantasyPointsDraftKings",
          hint: "Fantasy Points",
        },
      ],
      seasonHeader: [
        { text: "Season", value: "Season", width: "auto" },
        { text: "Team", value: "Opponent" },
        { text: "FUM", value: "Fumbles", hint: "fumbles" },
        { text: "FF", value: "FumblesForced", hint: "fumbles forced" },
        { text: "LNG", value: "ReceivingLong", hint: "Receiving long" },
        { text: "TGT", value: "ReceivingTargets", hint: "Receiving target" },
        {
          text: "TD",
          value: "ReceivingTouchdowns",
          hint: "Receiving touchdowns",
        },
        { text: "YDS", value: "ReceivingYards", hint: "Receiving yards" },
        { text: "REC", value: "Receptions", hint: "Receptions" },
        { text: "ATT", value: "RushingAttempts", hint: "Rushing Attempts" },
        { text: "LNG", value: "RushingLong", hint: "Rushing long" },
        {
          text: "TD",
          value: "RushingTouchdowns",
          hint: "Rushing touchdowns",
        },
        { text: "YDS", value: "RushingYards", hint: "Rushing yards" },
        {
          text: "FP",
          value: "FantasyPointsDraftKings",
          hint: "Fantasy Points",
        },
      ],
    };
  },
};
</script>

<style scoped>
.basil {
  background-color: #fffbe6 !important;
}

.basil--text {
  color: #356859 !important;
}
</style>
